// tslint:disable: no-implicit-dependencies
import { LinkButton } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { useIsMobileDevice } from '../../../hooks';
import * as styles from './styles.module.css';
const imgDesktop = require('!url-loader!./assets/desktopHomeowner.svg');
const imgMoble = require('!url-loader!./assets/mobileHomeowner.svg');

export const CandidateSuccessScreenHomeownerPayment = () => {
  const isMobile = useIsMobileDevice();

  return (
    <div
      {...mergeStyles(
        styles['container'],
        isMobile && styles['container-mobile'],
      )}
    >
      <div
        {...mergeStyles(styles['title'], isMobile && styles['title-mobile'])}
      >
        Объявление проходит модерацию.
        <br />
        Что будет дальше?
      </div>
      <div
        {...mergeStyles(styles['scroll'], isMobile && styles['scroll-mobile'])}
      >
        <div>
          {isMobile ? (
            <img className={styles['img-mobile']} src={imgMoble} />
          ) : (
            <img className={styles['img-desktop']} src={imgDesktop} />
          )}
        </div>
        <div
          {...mergeStyles(styles['list'], isMobile && styles['list-mobile'])}
        >
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
              !isMobile && styles['first-item-desktop'],
            )}
          >
            <div className={styles['item-title']}>Загрузите паспорт</div>
            <div className={styles['item-description']}>
              После проверки объявления модерацией, мы советуем сразу загрузить
              паспорт в Личном кабинете. Паспорт необходим для подготовки вашего
              договора аренды.
            </div>
          </div>
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
              !isMobile && styles['second-item-desktop'],
            )}
          >
            <div className={styles['item-title']}>
              Выберите идеального жильца и заключите договор
            </div>
            <div className={styles['item-description']}>
              Выбирайте арендаторов из анкет в Личном кабинете, а мы примем
              звонки за вас. Когда вы определитесь с жильцом, то просто выберите
              его в личном кабинете, чтобы подписать онлайн договор аренды.
            </div>
          </div>
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
            )}
          >
            <div className={styles['item-title']}>Сдавайте без забот!</div>
            <div className={styles['item-description']}>
              Заходите на сайт только для заполнения суммы по счётчикам, а мы
              будем напоминать арендатору об оплате аренды. 1990 ₽ за подписку
              будут списываться автоматически из арендной платы.
            </div>
            <div className={styles['item-button']}>
              <LinkButton fullWidth size="M" href="https://my.cian.ru/">
                Личный кабинет
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
